const styles = {
    saveButton: {
        background: '#3876AA',
        borderRadius: '16px',
        width: '200px',
        height: '48px',
        textTransform: 'none',
    },
    addressField: {
        marginTop: '24px',
    },
    addressField2: {
        marginTop: '21px',
    },
    addressHeading: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        ontSize: '14px',
        lineHeight: '21px',
        color: '#8697AB',
        mt: 3,
    },
    buttonsContainer: {
        mt: 5,
    },
};
export default styles;
